import { render, staticRenderFns } from "./article-carousel.vue?vue&type=template&id=cf45cee6&scoped=true"
import script from "./article-carousel.vue?vue&type=script&lang=js"
export * from "./article-carousel.vue?vue&type=script&lang=js"
import style0 from "./article-carousel.vue?vue&type=style&index=0&id=cf45cee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf45cee6",
  null
  
)

export default component.exports